export default class Portfolio{
    constructor(userId){
        this.owner = userId;    
    } 
}